import React from 'react'
import styled from 'styled-components';
const Container = styled.footer`
display:flex;
height:auto;
${'' /* width:100vw; */}
background:#fff;
align-items:center;
justify-content:space-evenly;
box-shadow:0 -1px 4px 0 rgb(26 26 26 / 8%), 0 4px 8px 0 rgb(26 26 26 / 12%);
color:#000;
margin-top:10px;
span{
  width:250px;
  margin:0px 30px;
}
@media screen and (max-width:768px){
  display:flex;
  flex-direction:column;
  align-items:center;
  justify-content:center;

}

`
const Footer = () => {
  return (
    <Container>
      <span>Contact me:</span>
      <span>Phone:+33749105757</span>
      <span>Mail:mouhand@amazon.com</span>
    </Container>
  )
}

export default Footer
